import { call, takeEvery, put } from "redux-saga/effects"
import { createActions } from "reduxsauce"
import { del as apiDelete } from "api"
import { Creators as notificationCreators } from "modules/notifications/model"

export const { Types, Creators } = createActions({
  del: ["resource", "url", "deletedId", "options"],
  deleteSuccess: ["resource", "id", "result", "deletedId", "options"],
  deleteError: ["resource", "id", "error", "deletedId"],
}, {
  prefix: "ompnt/modules/deleter/",
})

// By default, non-graphql id is the url
function* deleteSaga({ resource, url, deletedId, options }) {
  try {
    const result = yield call(apiDelete, url)
    yield put(Creators.deleteSuccess(resource, url, result, deletedId, options))
    if (options && options.onSuccess) {
      yield put(notificationCreators.add("success", null, options.onSuccess))
    }
  } catch (error) {
    yield put(Creators.deleteError(resource, url, error, deletedId))
    if (options && options.onError) {
      yield put(notificationCreators.add("error", null, options.onError))
    }
  }
}

export function* saga() {
  yield takeEvery(Types.DEL, deleteSaga)
}
